import { defineComponent, reactive, watch, ref } from 'vue';
import { EnvironmentOutlined } from '@ant-design/icons-vue';
import { LoginService } from '@/services/login.service';
import { UserService } from '@/services/user.service';
import { useService } from '@kaokei/use-vue-service';
import VCode from '@/components/VCode.vue';
import ImageCode from '@/components/ImageCode.vue';
import { logger, phonePattern, imageCodePattern, setToken } from '@/utils';
import Sentry from '@/utils/sentry';
export default defineComponent({
  name: 'LoginDialogMobile',
  components: {
    VCode: VCode,
    ImageCode: ImageCode,
    EnvironmentOutlined: EnvironmentOutlined
  },
  setup: function setup() {
    var userService = useService(UserService);
    var loginService = useService(LoginService);
    var formRef = ref();
    var formState = reactive({
      phone: '',
      imageCode: '',
      code: ''
    });
    var formRules = reactive({
      phone: [{
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
      }, {
        pattern: phonePattern,
        message: '手机号不正确',
        trigger: 'blur'
      }],
      imageCode: [{
        required: true,
        message: '请输入图片验证码',
        trigger: 'blur'
      }, {
        pattern: imageCodePattern,
        message: '图片验证码不正确',
        trigger: 'blur'
      }],
      code: [{
        required: true,
        message: '请输入短信验证码',
        trigger: 'blur'
      }]
    });

    var onSubmit = function onSubmit() {
      formRef.value.validate().then(function () {
        return loginService.loginByMobile(formState.phone, formState.code).then(function (res) {
          setToken(res.token);
          return userService.initUserInfo().then(function () {
            loginService.hideLoginDialog();
            loginService.queryGoToEnvCheckDialog();
          });
        });
      }).catch(function (e) {
        Sentry.withScope(function (scope) {
          scope.setContext('Exception', e);
          var level = e !== null && e !== void 0 && e.errorFields ? Sentry.Severity.Debug : Sentry.Severity.Error;
          scope.setLevel(level);
          Sentry.captureMessage('提交登录表单失败');
        });
        logger.debug('提交登录表单失败 => ', e);
      });
    }; // 监听登录弹窗是否关闭


    watch(function () {
      return loginService.visible;
    }, function (visible) {
      if (!visible) {
        formRef.value.resetFields();
      }
    });
    return {
      labelCol: {
        span: 0
      },
      wrapperCol: {
        span: 24
      },
      formRef: formRef,
      formState: formState,
      formRules: formRules,
      onSubmit: onSubmit,
      loginService: loginService
    };
  }
});